import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type DeleteTaxRateRequest = {
  id: number;
};

export type DeleteTaxRateResponse = BaseResponse<null>;

async function deleteTaxRate(
  data: DeleteTaxRateRequest
): Promise<DeleteTaxRateResponse> {
  try {
    return (await axiosInstance.delete(`/Product/DeleteTaxRate?id=${data.id}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteTaxRate() {
  return useMutation<DeleteTaxRateResponse, Error, DeleteTaxRateRequest>(
    (variables) => deleteTaxRate(variables)
  );
}
